import { colors } from '../../Colors/colors'

export const reminders = {
   light: {
      remainderCard: {
         cardBgColor: 'bg-base-white',
         titleTextColor: 'text-gray-800',
         dateTextColor: 'text-gray-500',
         salesPipeLineTextColor: 'text-gray-600',
         alarmIconColor: colors['gray-500'],
         hoveredBorderColor: 'border-gray-300',
         popoverBorderColor: 'border-gray-200',
         trashIconColor: colors['error-500'],
         deleteTextColor: 'text-error-600',
         calendarIconColor: colors['gray-600'],
         dotsVerticalIconColor: colors['gray-600'],
         verticalDotColor: colors['gray-500'],
         renameIconColor: colors['gray-500'],
         checkCirCleIcon: colors['gray-600'],
         noAssigneeBgColor: 'bg-gray-100',
         noAssigneeTextColor: 'tex-gray-600',
         renameTitleTextColor: 'text-gray-900',
         triggerHoverColor: 'hover:bg-gray-50',
         hoverColor: 'bg-gray-50',
         tooltipBgColor: 'bg-gray-900'
      },
      noDataView: {
         titleTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600'
      },
      reminderHeader: {
         headerBgColor: 'bg-base-white',
         reminderTitleTextColor: 'text-gray-900',
         borderBottomColor: 'border-gray-300',
         selectedDateTextColor: 'text-gray-700',
         chevronIconColor: colors['gray-500'],
         featureCalendarIconFillColor: colors['primary-100'],
         calendarIconBgColor: colors['primary-600']
      },
      reminderSidePane: {
         XCloseIconColor: colors['gray-500'],
         sidePaneBgColor: 'bg-base-white'
      },
      reminderMoreActions: {
         actionItemHoverColor: 'hover:bg-gray-50',
         actionItemTextColor: 'text-gray-700',
         optionTextColor: 'text-gray-900',
         popOverBgColor: 'bg-base-white',
         dividerBgColor: 'bg-blue-gray-200'
      },
      allRemindersForUser: {
         containerBackgroundColor: 'bg-gray-100'
      },
      pushNotificationCard: {
         cardBorderColor: 'border-gray-100'
      }
   },
   dark: {}
}
